import GridContainer from "components/UI/Grid/GridContainer.js";
import { ArrowForwardIos, Search } from "@material-ui/icons";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import CustomPopover from "components/UI/CustomPopover/CustomPopover";
import PopoverButton from "components/UI/CustomPopover/PopoverButton";
import GridItemTS from "components/UI/Grid/GridItemTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useSubcontractors } from "services/input-core/subcontractors/get-subcontractors";
import { TitlePages } from "components/UI/TitlePage/TitlePages";

interface SubcontractorProps {
  supplierCode?: string;
}

export default function List(props: SubcontractorProps) {
  const navigate = useNavigate();
  const { t } = useTranslation("sow-table");

  const { data, isLoading, isError } = useSubcontractors();

  const loadSubcontractorProfile = (subcontractorId: string) => {
    const currentUrl = window.location.href.substring(
      0,
      window.location.href.indexOf("/app"),
    );
    window.location.href = `${currentUrl}/app/subcontractors/profile?id=${subcontractorId}`;
  };

  const formatData = () => {
    if (props.supplierCode)
      return (
        data
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ?.map((subcontractor: any, index: number) => ({
            subcontractorName: subcontractor.name,
            taxId: subcontractor.taxId,
            supplierCode: subcontractor.supplierCode,
            actions: (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <CustomPopover identifier={`subcontractors-${index}`}>
                  <PopoverButton
                    onClick={() => loadSubcontractorProfile(subcontractor._id)}
                  >
                    <ArrowForwardIos style={{ fontSize: "1.2rem" }} />
                    {t("Access subcontractor")}
                  </PopoverButton>
                </CustomPopover>
              </div>
            ),
          }))
          .filter(
            (subcontractor) =>
              subcontractor.supplierCode === props.supplierCode,
          ) || []
      );
    else
      return (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data?.map((subcontractor: any) => ({
          subcontractorName: subcontractor.name,
          taxId: subcontractor.taxId,
          supplierCode: subcontractor.supplierCode,
          actions: (
            <div className="actions-right">
              <ButtonTS
                justIcon
                color="primary"
                round
                size="sm"
                aria-label="Access subcontractor"
                onClick={() => navigate(`../profile?id=${subcontractor._id}`)}
              >
                <ArrowForwardIos />
              </ButtonTS>
            </div>
          ),
        })) || []
      );
  };

  const content = () => {
    if (isError) {
      return [
        <td colSpan={4}>
          Something went wrong when trying to get the subcontractors
        </td>,
      ];
    }

    if (isLoading) {
      return <Skeleton />;
    }

    if (data?.length === 0) {
      return <div>No data</div>;
    }

    return (
      <ReactTable
        columns={[
          {
            Header: t("name"),
            accessor: "subcontractorName",
          },
          {
            Header: t("taxId"),
            accessor: "taxId",
          },
          {
            Header: t("supplier"),
            accessor: "supplierCode",
          },
          {
            Header: t("actions"),
            accessor: "actions",
          },
        ]}
        data={formatData()}
        id="subcontractors-table"
        columnsNotTrimFilters={["subcontractorName", "taxId"]}
      />
    );
  };

  return (
    <GridContainer>
      <GridItemTS xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Search />
            </CardIcon>

            <TitlePages type="sidebar" title="subcontractors" />
          </CardHeader>
          <CardBody>{content()}</CardBody>
        </Card>
      </GridItemTS>
    </GridContainer>
  );
}
